import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Drawer } from '@material-ui/core';
import ComFunction from "../components/ComFunction";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom";
import { resetform, setmenuinfo } from '../modules/formstore';
import { continueSession } from '../modules/appLibrary';

const useStyles = makeStyles({
    list: {
        width: 250
    },
    fullList: {
        width: "auto"
    },
    paper: {
        background: "#F5F7F7"
    }
});

//---------------------------------------------------------------------
//  DataTree
//---------------------------------------------------------------------
export default function DataTree(props) {
    const fnc = useRef();
    const ComFunc = React.forwardRef(ComFunction);

    const dispatch = useDispatch();
    const open = useSelector(state => state.form.datatreeopen);
    const datatreelist = useSelector(state => state.form.datatreelist);
    const formstatus = useSelector(state => state.form.status);
    const menus = useSelector(state => state.menu.menus);       //個人メニュまたは既定メニュ
    const modify = useSelector(state => state.form.modify);
    const [show, setshow] = useState(false)
    const [list, setlist] = useState([])
    const classes = useStyles();
    const history = useHistory();
    const user = useSelector(state => state.user);
    const menudata = useSelector(state => state.menu);

    useEffect(() => {
        setshow(open);
    }, [open])

    useEffect(() => {
        setlist(datatreelist);
    }, [datatreelist])


    function Apply(value,e) {
        if (!value.valid) {
            fnc.current.warnmsg("権限がないため実行できません");
            return;
        }
        var ctrl = (e.ctrlKey && !e.metaKey) || (!e.ctrlKey && e.metaKey);
        if (modify) {
            fnc.current.confmsg("編集中の内容は破棄されます。よろしいですか？", () => historypush(value, ctrl));
        } else {
            historypush(value,ctrl);
        }
    }
    function historypush(value,ctrl) {
        onHandleClose();
        //history add
        if (formstatus === "ENTRY FORM") {
            const state = { status: "ENTRY", code: props.code };
            const url = new URL(window.location);
            window.history.pushState(state, '', url);
        }

        var state = { status: "ENTRY", code: value.key, accepttype: value.accepttype, acceptno: props.code };
        var menu = menus.find(e => e.controller === value.controller);
        if (ctrl) {
            //別タブ起動
            let key = continueSession(user, menudata, menu, state);
            let newurl = value.controller;
            if (newurl.indexOf('?') === -1) {
                newurl += "?key=" + key;
            } else {
                newurl += "&key=" + key;
            }
            window.open('/' + newurl);
        } else {
            //画面遷移
            dispatch(resetform());
            dispatch(setmenuinfo(menu));
            if (value.controller.indexOf('?') === -1)
                history.push(
                    {
                        pathname: "/" + value.controller,
                        state: state
                    });
            else
                history.push(
                    {
                        pathname: "/" + value.controller.split('?')[0],
                        search: '?' + value.controller.split('?')[1],
                        state: state
                    });
        }
    }

    function onHandleClose() {
        fnc.current.datatreeclose();
    };

    return (
        <div>
            <Drawer classes={{ paper: classes.paper }} anchor={"left"} open={show} onClose={onHandleClose} BackdropProps={{ invisible: true }}>
                <div style={{ marginRight: 10, minWidth:200 }}>
                    <div style={{ textAlign: 'left', float: 'left', marginTop: 10, marginLeft: 10}}>
                        <span >Data Tree</span>
                    </div>
                </div>
                {list.length !== 0 ? null :
                    <div style={{ color: '#aaa', marginLeft: 20, marginTop:50 }}>関連データはありません</div>
                }
                <List
                    sx={{ width: '100%', bgcolor: 'background.paper' }}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                >
                    {list.map(item => (
                        item.title ?
                            <ListItem><ListItemText primary={item.label} /></ListItem>
                            :
                            <ListItem button onClick={(e) => Apply(item,e)}>
                                <ListItemText
                                    disableTypography
                                    primary={<Typography style={{ marginLeft: 30, marginRight:50 }}>{item.label}</Typography>}
                                />
                            </ListItem>
                    ))}
                </List>

            </Drawer>
            <ComFunc ref={fnc} />
        </div>
    );
};
